import type { ChunkType, WorkerJob } from '../types/Media';

export class WorkerPool {
  private size: number = 0;
  private workers: number = 0;
  private jobs: WorkerJob[] = [];
  protected static instance: WorkerPool;

  constructor(size: number) {
    if (WorkerPool.instance) {
      return WorkerPool.instance;
    }

    this.size = size;
    this.workers = 0;
    this.jobs = [];
    WorkerPool.instance = this;
  }

  static getInstance(size: number) {
    if (!WorkerPool.instance) {
      WorkerPool.instance = new WorkerPool(size);
    }
    return WorkerPool.instance;
  }

  queueJob(url: string, msg: ChunkType, cb: (data: any, worker: Worker) => Promise<number | boolean>) {
    const job = { url, msg, cb };
    this.jobs.push(job);
    if (this.workers < this.size) this.nextJob();
  }

  nextJob() {
    if (this.jobs.length > 0 && this.workers < this.size) {
      const job = this.jobs.shift();
      if (job) {
        const worker = new Worker(job.url);
        this.workers++;

        worker.addEventListener(
          'message',
          async (e) => {
            await job.cb(e.data, worker);
            worker.terminate();
            this.workers--;
            this.nextJob();
          },
          false
        );
        worker.postMessage(job.msg);
      }
    }
  }
}
